<style>
.ivu-radio-group{
  display: block;
  margin-bottom: 10px;
}
</style>
<template>
	<Layout>
		<Content :style="{'padding': '10px'}">
			<Breadcrumb :style="{margin: '5px 0'}">
				<BreadcrumbItem>通用管理 > <b>消息通知列表</b></BreadcrumbItem>
			</Breadcrumb>
			<Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
				<span class="search_span_width">
					<span class="search_span_width_part1">标题：</span>
					<Input v-model="search.title" placeholder="请输入标题" :style="{'width':'110px'}"></Input>
				</span>
				<Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList(1)">搜索</Button>
			</Card>
			<Card>
				<p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
					<span :style="{'text-align':'center','float':'left'}">
						<Button type='primary' :style="{'margin-left':'5px'}" @click="addModal()">添加消息通知</Button>
					</span>
				</p>
				<Card id="tableContent" >
					<Table :columns="tableColumns" row-key="id" update-show-children :data="recordList"></Table>
					<Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getList"/>
				</Card>
			</Card>
		</Content>
		<Modal v-model="showmodal" :footer-hide=true title="消息通知">
			<Form ref="info" :model="info" :label-width="80" :rules="editRule">
				<FormItem label="标题" prop="title">
					<Input v-model="info.title"/>
				</FormItem>
				<FormItem label="内容" prop="content">
					<Input type="textarea" v-model="info.content" :autosize="{minRows: 5,maxRows: 30}"/>
				</FormItem>
				<FormItem>
					<Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
					<Button type="primary" @click="upsert()">提交</Button>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="shownmodal" :footer-hide=true title="添加通知人">
			<Form ref="sel" :model="sel" :label-width="80">
				<FormItem label="选择代理商" prop="agents">
					<Tree :data="agentList" ref="treeRef" show-checkbox multiple></Tree>
				</FormItem>
				<FormItem>
					<Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
					<Button type="primary" @click="upsertUser()">提交</Button>
				</FormItem>
			</Form>
		</Modal>
	</Layout>
</template>
<script>
export default {
	data(){
		return {
			search:{
				title:"",
			},
			info:{
				id:0,
				title:"",
				content:"",
			},
			showmodal:false,
			shownmodal:false,
			recordList:[],
			recordTotal:0,
			page:1,
			sel:{
				id:0,
				agents:[],
			},
			agentList:[],
			checkedGrandchildren:[],
			editRule :{
				title:[
					{ required: true, message: '标题不能为空', trigger: 'blur' },
					{ max: 11, message: '标题长度不能超过11个字', trigger: 'blur' } 
				],
				content: [
					{ required: true, message: '内容不能为空', trigger: 'blur' },
					{ max: 500, message: '内容长度不能超过500个字', trigger: 'blur' }
				],
			},
			tableColumns:[
				{ title: 'ID', key: 'id', align: 'center',tree: true },
				{ title: '标题', key: 'title', align: 'center' },
				{ title: '内容', key: 'content', align: 'center' },
				{ title: '创建时间', key: 'created_at', align: 'center'},
				{ title: '更新时间', key: 'updated_at', align: 'center'},
				{ title: '操作', key: 'action', align: 'center',
					render: (h, params) => {
						let btns = []
						btns.push(
							h('Button', {
								props: { type: 'warning', size: 'small' },
								style: { marginRight: '5px', marginBottom: '5px'},
								on: {
									click: () => {        
										this.info.id = params.row.id;
										this.info.title = params.row.title;
										this.info.content = params.row.content;
										this.showmodal = true;
									}
								}
							}, '编辑'),
						);
						btns.push(
							h('Button', {
								props: { type: 'error', size: 'small' },
								style: { marginRight: '5px', marginBottom: '5px'},
								on: {
									click: () => {
										this.del(params.row.id);
									}
								}
							}, '删除'),
						);
						btns.push(
							h('Button', {
								props: { type: 'success', size: 'small' },
								style: { marginRight: '5px', marginBottom: '5px'},
								on: {
									click: () => {      
										this.sel.id = params.row.id;
										this.getAgentList(params.row.id);
										this.shownmodal = true;
									}
								}
							}, '添加通知人'),
						);
						return h("div", btns);
					}
				}
			],
		}
	},
	mounted:function(){
		this.getList();
	},
	computed:{},
	methods:{
		addModal(){
			this.info.id = 0;
			this.info.title = '';
			this.info.content = '';
			this.showmodal = true;
		},
		closeModal(){
			this.info.id = 0;
			this.info.title = '';
			this.info.content = '';
			this.showmodal = false;
			this.shownmodal = false;
		},
		getList(page = this.page){
			this.page = page;
			let p = {'page':page};
			let params = Object.assign(this.search, p);
			this.http1.get('/notice/list', {params:params}).then(response=>{
				let data = response.data;
				if (data.code !== 0){
					alert(data.message);
				} else {
					this.recordList = data.data.list;
					this.recordTotal = data.data.total;
				}
			}).catch(()=>{
				this.$Message.error('网络错误');
			});
		},
		getAgentList(id){
			let params = {'id':id};
			this.http1.get('/notice/getUser', {params:params}).then(response=>{
				let data = response.data;
				if (data.code !== 0) {
					alert(data.message);
				} else {
					this.agentList = [
						{
							title: '全渠道代理商',
							expand: true,
							children: []
						}
					];
					data.data.forEach(item => {
						const pt = {
							title:item.name,
							expand:false,
							children:[]
						};
						item.children.forEach(ele => {
							pt.children.push(
								{
									id:ele.id,
									title:ele.name,
									checked:ele.checked
								}
							);
						});
						this.agentList[0].children.push(pt);
					});
					//console.log(this.agentList);
				}
			}).catch(()=>{
				this.$Message.error('网络错误');
			});
		},
		upsert(){
			this.$refs["info"].validate((valid) => {
				if(valid){
					this.http1.post('/notice/upsert', this.info).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							alert(data.message);
						} else {
							this.getList(this.page);
							this.showmodal = false;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				}else{
					this.$Message.error('标题/内容不满足要求');
				}
			});
		},
		del(id){
			this.$Modal.confirm({
				content: '<p>确定删除？删除可能会影响已接收该通知的用户</p>',
				onOk: () => {
					this.showAllmodal = false;
					this.http1.post('/notice/del', {id:id}).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							this.$Message.error(data.message);
							return false;
						} else {
							this.$Message.info('删除成功');
							this.getList(this.page);
							return true;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				},
			});
		},
		upsertUser(){
			this.checkedGrandchildren = [];
			const checkedNodes = this.$refs.treeRef.getCheckedNodes();
			checkedNodes.forEach(node => {
				this.getGrandchildren(node);
			});
			this.sel.agents = this.checkedGrandchildren;
			//console.log(this.sel.agents);
			this.http1.post('/notice/upsertUser', this.sel).then(response=>{
				let data = response.data;
				if (data.code !== 0) {
					this.$Message.error(data.message);
					return false;
				} else {
					this.shownmodal = false;
					this.getList(this.page);
					return true;
				}
			}).catch(()=>{
				this.$Message.error('网络错误');
			});
		},
		getGrandchildren(node) {
			if (node.children && node.children.length > 0) {
				node.children.forEach(child => {
					if (child.checked) {
						const idExists = this.checkedGrandchildren.some(id => id === child.id);
						if (!idExists) {
							this.checkedGrandchildren.push(child.id);
						}
					}
					this.getGrandchildren(child);
				});
			} else {
				if (node.checked) {
					const idExists = this.checkedGrandchildren.some(id => id === node.id);
					if (!idExists) {
						this.checkedGrandchildren.push(node.id);
					}
				}
			}
		}
	}
}
</script>
